import { portalApi } from '@/axios'

export default class PermissionService {
  /**
   * Get permissions.
   *
   * @param {Context} context
   *
   * @return {Promise}
   */
  static getPermissions (context) {
    return portalApi.get(this.endpoint(context)).then(response => {
      return response.data
    })
  }

  /**
   * Endpoint of API.
   *
   * @param {Context} context
   *
   * @return {string}
   */
  static endpoint (context) {
    if (context.isSelected('partner') || context.isSelected('business')) {
      return `user/${context.endpoint(context.isSelected('business') ? ['business', 'merchant'] : ['partner'])}/permissions`
    }

    return 'user/permissions'
  }
}
